import profileViewLogger from '../src/javascripts/profileViewLogger';

profileViewLogger();
